import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Layout from "./layout";
import SearchIcon from "@mui/icons-material/Search";
import TableSortLabel from "@mui/material/TableSortLabel";
import DownloadIcon from "@mui/icons-material/Download";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { jsPDF } from "jspdf";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { DialogActions, DialogContentText } from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import Divider from "@mui/material/Divider";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import "jspdf-autotable";
import "../App.css";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useAcademicYear } from "./AcademicYearContext";
import { List, ListItem, ListItemText } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import issueKitIcon from "../images/KitIssue.png";
import { getInstituteConfig } from "../utility/instituteConfig";

export default function IssueKits() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [search, setSearch] = useState("");
  const [order, setOrder] = React.useState("desc");
  const [orderBy, setOrderBy] = React.useState("assigned_kit_id");
  const [open, setOpen] = useState(false);
  const [statusName, setStatusName] = useState("");
  const [userId, setUserId] = useState("");
  const [loading, setLoading] = useState(false); // Loading state
  const [sortOrder, setSortOrder] = useState("desc"); // Sorting order: 'asc' or 'desc'
  const [sortColumn, setSortColumn] = useState("sl_no"); // Column to sort by
  const [openIssueKitDialog, setOpenIssueKitDialog] = useState(false);
  const navigate = useNavigate();
  const { academicYearId } = useAcademicYear();

  const [searchResults, setSearchResults] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [searchResultsKit, setSearchResultsKit] = useState([]);
  const [selectedKit, setSelectedKit] = useState();
  const [searchQueryKit, setSearchQueryKit] = useState("");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarMessageColor, setSnackbarMessageColor] = useState("");
  const [showSnackbarMessage, setShowSnackbarMessage] = useState(false);
  const [status, setStatus] = useState([]);
  const [statusId, setStatusId] = useState();

  const [deletedRows, setDeletedRows] = useState();
  const [openDelete, setOpenDelete] = useState();
  const [kitError, setKitError] = useState();
  const [studentError, setStudentError] = useState();
  const [isStudentSelected, setIsStudentSelected] = useState();
  const [assignedKits, setAssignnedKits] = useState([]);
  const [kitProducts, setKitProducts] = useState([{}]);
  const [assignedKitId, setAssignnedKitId] = useState();
  const [dialogType, setDialogType] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [checkBoxOpen, setCheckBoxOpen] = React.useState(false);
  const [loadingStudent, setLoadingStudent] = useState(false); // Loading state
  const [loadingProduct, setLoadingProduct] = useState(false);
  const [kitName, setKitName] = useState(false);
  const [kitId, setKitId] = useState();
  const [kitQuantity, setKitQuantity] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openConfirmationDuplicate, setOpenConfirmationDuplicate] =
    useState(false);
  const [duplicateKit, setDuplicateKit] = useState([]);
  const [allSearchData, setAllSearchData] = useState([]); // for students/staff
  const [allKitData, setAllKitData] = useState([]);

  const instituteId = localStorage.getItem("instituteId");

  useEffect(() => {
    if (selectedStudent) {
      getAssignedKit();
    }
  }, [selectedStudent, isStudentSelected]);

  const handleCloseConfirm = () => {
    setOpenConfirmation(false);
    setOpenConfirmationDuplicate(false); // Close dialog
    setAssignnedKitId(null);
    setOpenIssueKitDialog(false);
    setIsStudentSelected(false);

    setSelectedKit();
    setSelectedStudent();
    getAssignedKit();
    setDeletedRows();
  };

  const handleConfirmDuplicateKit = () => {
    setOpenConfirmationDuplicate(false); // Close dialog
    saveAssignedKit(true); // Retry with forceIssue: true
    getAssignedKit();
    setOpenIssueKitDialog(false);
    setIsStudentSelected(false);
    setAssignnedKitId(null);
  };
  useEffect(() => {
    console.log("Received Academic Year ID:", academicYearId);
  }, [academicYearId]);
  const triggerSnackbar = (message, color = "info") => {
    setShowSnackbarMessage(false);
    setTimeout(() => {
      setSnackbarMessage(message);
      setSnackbarMessageColor(color);
      setShowSnackbarMessage(true);
    }, 100);
  };
  useEffect(() => {
    if (openIssueKitDialog && selectedKit?.kit_quantity === 0) {
      triggerSnackbar(
        "Selected kit is out of stock. Please select another kit or contact the Store Manager.",
        "error",
      );
    }
  }, [openIssueKitDialog, selectedKit]);
  const handleStatusChange = (event) => {
    setStatusName(event.target.value);
    let kitStatusId = status.find((s) => s.description === event.target.value);
    setStatusId(kitStatusId.sales_status_id);
  };
  const handleDownload = (row) => {
    // Prevent download if rows are empty or all rows contain no meaningful data
    const isDataEmpty =
      !assignedKits ||
      assignedKits.length === 0 ||
      assignedKits.every(
        (row) => !row.assigned_kit_id,
        !row.student_name !== " " ? !row.student_name : !row.staff_name,
        !row.staff_roles || !row.student_role,
        !row.student_contact_no || !row.staff_contact_no,
        !row.kit_name,
        !row.payment_date,
        !row.issue_date,
        !row.issued_by_name,
        !row.kit_status,
        !row.total_price,
      );

    if (isDataEmpty) {
      return;
    }
    // const institute =
   
     const institute = getInstituteConfig(instituteId);

    const doc = new jsPDF();

    // Header background
    doc.setFillColor("#0A64A2");
    const headerHeight = 20;
    doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

    // Logo
    if (institute.logo) {
      doc.addImage(institute.logo, "PNG", 9, 1, 28, 18);
    }

    // School Name
    const textStartY = 11;
    doc.setFontSize(14);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.text(institute.name, doc.internal.pageSize.getWidth() / 2, textStartY, {
      align: "center",
    });

    // Address
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.text(
      institute.address1,
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 14,
      { align: "center" },
    );
    doc.text(
      institute.address2,
      doc.internal.pageSize.getWidth() / 2,
      textStartY + 18,
      { align: "center" },
    );
    if (institute.tel) {
      doc.text(
        institute.tel,
        doc.internal.pageSize.getWidth() / 2,
        textStartY + 22,
        { align: "center" },
      );
    }
    // Add Receipt Title, Number, and Date - Right aligned
    const receiptTextY = textStartY + 36; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(
      "ISSUE KIT REPORT",
      doc.internal.pageSize.getWidth() / 2,
      receiptTextY,
      { align: "center" },
    ); // Center aligned title // Center aligned title
    doc.setFontSize(10);

    let studentDetailsY = receiptTextY + 10; // Adjust Y position after receipt info

    // Set font for student name and details
    doc.setFont("helvetica", "bold");

    // Date
    const currentDate = new Date();
    const formattedDate = `${String(currentDate.getDate()).padStart(2, "0")}/${String(currentDate.getMonth() + 1).padStart(2, "0")}/${currentDate.getFullYear()}`;
    doc.setFont("helvetica", "bold");
    doc.text(`Date: `, 169, studentDetailsY);
    doc.setFont("helvetica", "normal");
    doc.text(`${formattedDate}`, 178, studentDetailsY);

    const totalAmount = assignedKits.reduce((sum, row) => {
      const price = row.kit_price
        ? parseFloat(row.kit_price.replace(/[^0-9.]/g, ""))
        : 0;
      return sum + price;
    }, 0);

    const tableData = assignedKits.map((row) => {
      return [
        row.assigned_kit_id,
        row.student_name !== " " ? row.student_name : row.staff_name,
        row.staff_roles || row.student_role,
        row.student_contact_no || row.staff_contact_no,
        row.kit_name,
        row.payment_date,
        row.issue_date,
        row.issued_by_name,
        row.kit_status,
        row.kit_price ? row.kit_price.replace(/[^0-9.]/g, "") : "0.00",
        totalAmount.toLocaleString(),
      ];
    });

    tableData.push([
      "", // Empty for Student ID
      "", // Label for the totals
      "", // Empty for Fees Slab
      "", // Empty for Parent Name
      "", // Grand total label
      "", // Total Amount Paid
      "", // Total Amount Pending
    ]);
    tableData.push(["", "", "", "", "", "", "", "", "Total:", totalAmount]);

    // Table settings
    doc.autoTable({
      head: [
        [
          "Indent ID",
          "Name",
          "Role",
          "Contact No",
          "Kit Name",
          "Payment Date",
          "Issue Date",
          "Issued By ",
          "Status",
          "Total Amount",
        ],
      ],
      body: tableData,
      startY: receiptTextY + 13, // Adjusted based on dynamic content
      styles: { fontSize: 8, halign: "center" },
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
        alignItems: "center",
      },
      theme: "grid",
      // Make the last row (Grand Total) bold
      didParseCell: (data) => {
        if (data.row.index === tableData.length - 1) {
          // Check if it's the last row
          data.cell.styles.fontStyle = "bold"; // Set font style to bold
        }
      },
    });

    // Save the PDF
    doc.save(`issue_kit_report_${new Date().toISOString().slice(0, 10)}.pdf`);
  };

  const handleCheckboxClick = async (row) => {
    setKitId(row.kit_id);
    setKitQuantity(row.quantity);
    const kitProductData = await getKitProducts(row.kit_id);

    // Handle different statuses
    if (row.kit_status === "Created") {
      setDialogMessage(
        `Kit cannot be issued because the payment for Indent ID ${row.assigned_kit_id} has not been completed.`,
      );
      setDialogType("info");
      setCheckBoxOpen(true);
      return;
    } else if (row.kit_status === "Paid") {
      setCheckBoxOpen(true);
      setDialogMessage(
        `Are you sure you want to update status for Indent ID ${row.assigned_kit_id} from "Paid" to "Issued"?`,
      );
      setDialogType("confirmation");
    }

    // Store the sales ID for use later
    setAssignnedKitId(row.assigned_kit_id);

    if (row.kit_status === "Paid" && row.kit_quantity === 0) {
      setDialogMessage(
        `Kit cannot be issued as stock is not available for kit ID ${row.kit_id}.`,
      );
      setDialogType("error");
      setCheckBoxOpen(true);
      return;
    }
    if (
      row.kit_status === "Paid" &&
      kitProductData?.kitProduct &&
      kitProductData.kitProduct.some(
        (item) => parseInt(item.quantity) > parseInt(item.product_quantity),
      )
    ) {
      const invalidProducts = kitProductData.kitProduct.filter(
        (item) => parseInt(item.quantity) > parseInt(item.product_quantity),
      );
      // If no products have insufficient stock, don't show the error message
      if (invalidProducts.length === 0) return;
      const productDetails = invalidProducts
        .map((p) => `${p.product_name.trim()} (ID: ${p.product_id})`)
        .join(", ");

      setDialogMessage(
        `Kit cannot be issued as stock is not available for the following product(s): ${productDetails}.`,
      );
      setDialogType("error");
      setCheckBoxOpen(true);
      return;
    }

    // ✅ Open the dialog
    setCheckBoxOpen(true);
  };
  const handleIssueKit = async () => {
    setCheckBoxOpen(false);

    try {
      // Wait for kit products to be fetched
      const kitProductsData = await getKitProducts(kitId);
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/updatKitStatus",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            assigned_kit_id: assignedKitId,
            issue_date: new Date(),
            issued_by: userId,
            kit_id: kitId,
            quantity: kitQuantity,
            kitProducts: kitProductsData,
          }),
        },
      );
    } catch (error) {
      console.error("Error fetching  details:", error);
    }
    getAssignedKit();
  };

  const closeCheckBox = () => {
    setCheckBoxOpen(false);
    setKitProducts([]);
  };

  const getAssignedKit = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/getIssueKit",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            kit_status_id: statusId || null,
            academic_year_id: academicYearId,
          }),
        },
      );
      if (response.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return null; // Stop further execution
      }
      const data = await response.json();
      setAssignnedKits(data);

      // ✅ Extract assigned kit for selected student or staff
      const selectedId = isStudentSelected ? selectedStudent?.id : null;
      const selectedStaffId = isStudentSelected ? null : selectedStudent?.id;

      console.log("SelectedId", selectedId);
      console.log("TRUYE", isStudentSelected);
      const filteredKit = data.find((kit) =>
        isStudentSelected
          ? kit.student_id === selectedId
          : kit.staff_id === selectedStaffId,
      );
      //  console.log("filteredKit",filteredKit)

      // if (filteredKit) {
      //   console.log("Assigned kit name:", filteredKit.kit_name);
      //   setDuplicateKit(filteredKit.kit_name); // Optional: store in state
      // } else {
      //   console.log("No kit assigned to selected user.");
      //   setDuplicateKit(null);
      // }

      const filteredKits = data.filter((kit) =>
        isStudentSelected
          ? kit.student_id === selectedId
          : kit.staff_id === selectedStaffId,
      );

      console.log("filteredKits:", filteredKits);
      if (filteredKits.length > 0) {
        const kitNames = filteredKits.map((kit) => kit.kit_name);
        console.log("Assigned kit names:", kitNames);
        setDuplicateKit(kitNames); // store as array of names
      } else {
        console.log("No kits assigned to selected user.");
        setDuplicateKit([]); // or null if you prefer
      }
    } catch (error) {
      console.error("Error fetching  details:", error);
    } finally {
      setLoading(false); // Ensure loading is set to false when done
    }
  };

  useEffect(() => {
    getAssignedKit();
  }, [statusId, academicYearId]);
  useEffect(() => {
    getAssignedKit();
  }, [academicYearId]);
  const getKitProducts = async (kitId) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_JHS_DEVELOPMENT + "/kits/getKitProduct",
        {
          method: "POST",
          headers: { "Content-type": "application/json" },
          body: JSON.stringify({
            kit_id: kitId,
          }),
        },
      );
      const data = await response.json();
      setKitProducts(data);
      setKitName(data?.kitProduct[0]?.kit_name);

      return data;
    } catch (error) {
      console.error("Error fetching  details:", error);
    }
  };

  const handleProductList = (kitId) => {
    getKitProducts(kitId);
    setOpen(true);
  };
  const handleCloseProducts = () => {
    setOpen(false);
    if (openIssueKitDialog && selectedKit?.kit_quantity === 0) {
      triggerSnackbar(
        "Selected kit is out of stock. Please select another kit or contact the Store Manager.",
        "error",
      );
    }
  };
  const totalProductPrice = (kitProducts?.kitProduct || []).reduce((sum, p) => {
    return sum + parseFloat(p.price) * p.quantity; // Ensure price is numeric
  }, 0);

  const saveAssignedKit = async (forceIssue = false) => {
    let studentError = "";
    let kitError = "";

    // Validate Payment Date
    if (!selectedStudent || selectedStudent.length < 0) {
      studentError = "Student / Staff is required";
    }
    if (!selectedKit || selectedKit.length < 0) {
      kitError = "Kit is required";
    }

    // Set errors and return if any validations fail
    if (kitError || studentError) {
      setKitError(kitError);
      setStudentError(studentError);

      return; // Prevent form submission if there are errors
    }

    // // Reset error state after successful validation
    setKitError("");
    setStudentError("");

    try {
      setIsLoading(true);
      // First API call: saveKit
      const assignKit = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/kits/saveAssignedKit`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            kit_id: selectedKit?.kit_id,

            staff_id: isStudentSelected ? null : selectedStudent?.id,
            student_id: isStudentSelected ? selectedStudent?.id : null,
            academic_year_id: academicYearId,
            quantity: selectedKit?.quantity,
            total_price: selectedKit?.total_price,
            kit_price: selectedKit?.total_price,
            kit_status_id: 1,
            created_by: userId,
            forceIssue, // <-- support for duplicate confirmation
          }),
        },
      );

      if (assignKit.status === 401) {
        console.log("Unauthorized access, redirecting to Sign-In...");
        navigate("/signin"); // Redirect if unauthorized
        return null; // Stop further execution
      }
      if (assignKit.status === 400) {
        console.log("Kit has already been assigned to this student.");
        setOpenConfirmation(true);

        return null; // Stop further execution
      }

      if (assignKit.status === 200) {
        const result = await assignKit.json();
        if (result.askConfirmation) {
          console.log(
            "Kit already issued this year. Ask user if they want to assign another.",
          );
          setOpenConfirmationDuplicate(true);
          return;
        }

        // const assignKitData = await assignKit.json();
        setIsStudentSelected(false);
        setOpenIssueKitDialog(false);
        setSelectedKit();
        setSelectedStudent();
        getAssignedKit();
        setAssignnedKitId(null);
        setSnackbarMessage("Kit assigned successfully");
        setSnackbarMessageColor("success");
        setShowSnackbarMessage(true);
        setDeletedRows(null);
        setOpenConfirmation(false);
      }
    } catch (error) {
      console.error("Error in saving kit and associating products:", error);
    } finally {
      setIsLoading(false); // Always stop loading regardless of success or failure
    }
  };
  const handleSelectRow = (
    assigned_kit_id,
    student_id,
    staff_id,
    staff_name,
    student_name,
    student_role,
    staff_roles,
    student_grade,
    student_section,
    kit_id,
    total_price,
    kit_name,
    kit_description,
    quantity,
    kit_quantity,
    kit_status,
  ) => {
    if (kit_status === "Created") {
      setOpenIssueKitDialog(true);
      setAssignnedKitId(assigned_kit_id);

      setSelectedStudent({
        id: student_id || staff_id,
        name:
          student_name && student_name.trim() !== ""
            ? student_name
            : staff_name,
        role: student_role || staff_roles,
        grade: student_grade,
        section: student_section,
      });
      if (student_role === "Student") {
        setIsStudentSelected(true);
      }

      setSelectedKit({
        kit_description: kit_description,
        kit_id: kit_id,
        kit_name: kit_name,
        kit_quantity: kit_quantity,
        maxQuantity: quantity,
        quantity: quantity,
        total_price: total_price,
      });
    }
  };

  const EditAssignedKit = async () => {
    // let studentError = "";
    let kitError = "";

    // // Validate Payment Date
    // if (!searchQuery || searchQuery.trim() === "") {
    //   studentError = "Student / staff is required";
    // }
    if (!selectedKit) {
      kitError = "Kit is required";
    }

    // // Set errors and return if any validations fail
    if (
      kitError
      // studentError
    ) {
      setKitError(kitError);
      // setStudentError(studentError);

      return; // Prevent form submission if there are errors
    }

    // // Reset error state after successful validation
    setKitError("");
    // setStudentError("");

    try {
      // First API call: saveKit
      const editAssignKit = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/kits/editAssignedKit`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            kit_id: selectedKit?.kit_id,
            assigned_kit_id: assignedKitId,
            staff_id: isStudentSelected ? null : selectedStudent?.id,
            student_id: isStudentSelected ? selectedStudent?.id : null,
            academic_year_id: academicYearId,
            quantity: selectedKit?.quantity,
            total_price: selectedKit?.total_price,
            kit_status_id: 1,
            updated_by: userId,
            updated_timestamp: new Date(),
          }),
        },
      );

      const editAssignKitData = await editAssignKit.json();
      console.log("SaveKit Response:", editAssignKitData);
      setIsStudentSelected(false);
      setOpenIssueKitDialog(false);
      setSelectedKit();
      setSelectedStudent();
      getAssignedKit();
      setAssignnedKitId(null);
      setDeletedRows();
      setSnackbarMessage("Assigned kit updated successfully");
      setSnackbarMessageColor("success");
      setShowSnackbarMessage(true);
    } catch (error) {
      console.error("Error in saving kit and associating products:", error);
    }
  };

  const handleDeleteProduct = () => {
    setOpenDelete(true);
  };

  const handleToggleDelete = (kitId, quantity) => {
    setDeletedRows(
      (prev) =>
        prev?.kit_id === kitId
          ? null // Remove if already marked
          : { kit_id: kitId, quantity }, // Store as a single object
    );
  };

  const handleDeleteConfirm = async () => {
    setSelectedKit((prevKit) =>
      prevKit?.kit_id === deletedRows?.kit_id ? null : prevKit,
    );
    setOpenDelete(false);
  };

  const handleCancelDelete = () => {
    setDeletedRows(null); // Clear the deleted selection
    setOpenDelete(false);
  };
  const getSaleStatus = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_JHS_DEVELOPMENT}/storepurchase/getSalesStatus`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      // Get only the first 3 values
      const filteredData = data.slice(0, 3);
      setStatus(filteredData);
    } catch (error) {
      console.error("Error fetching sales status:", error);
    }
  };

  useEffect(() => {
    getSaleStatus();
  }, []);

  // const fetchStudents = async (query) => {
  //   setLoadingStudent(true);
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_JHS_DEVELOPMENT}/student/getsearchresult?search=${encodeURIComponent(query)}`
  //     );
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch products");
  //     }
  //     const data = await response.json();
  //     const searchTerms = query.toLowerCase().split(" ").filter(Boolean);

  //     const filteredData = data.filter((row) =>
  //       searchTerms.some((term) => // Changed to some() for better filtering
  //         (row.id && row.id.toString().toLowerCase().includes(term)) ||
  //         (row.role_name && row.role_name.toLowerCase().includes(term)) ||
  //         (row.first_name && row.first_name.toLowerCase().includes(term)) ||
  //         (row.last_name && row.last_name.toLowerCase().includes(term)) ||
  //         (row.contact_no && row.contact_no.toString().toLowerCase().includes(term)) ||
  //         (row.grade_name && row.grade_name.toLowerCase().includes(term)) ||
  //         (row.role_name && row.role_name.toLowerCase().includes(term))
  //       )
  //     );

  //     setSearchResults(filteredData);
  //   } catch (error) {
  //     console.error("Error fetching products:", error);
  //   } finally {
  //     setLoadingStudent(false);
  //   }
  // };

  useEffect(() => {
    const fetchStudents = async () => {
      setLoadingStudent(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/student/getsearchresult`,
        );
        if (!response.ok) throw new Error("Failed to fetch data");
        const data = await response.json();
        setAllSearchData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoadingStudent(false);
      }
    };

    fetchStudents();
  }, []);

  useEffect(() => {
    if (!searchQuery.trim()) {
      setSearchResults([]);
      return;
    }

    const searchTerms = searchQuery.toLowerCase().split(" ").filter(Boolean);

    const filteredData = allSearchData.filter((row) =>
      searchTerms.some(
        (term) =>
          (row.id && row.id.toString().toLowerCase().includes(term)) ||
          (row.role_name && row.role_name.toLowerCase().includes(term)) ||
          (row.first_name && row.first_name.toLowerCase().includes(term)) ||
          (row.last_name && row.last_name.toLowerCase().includes(term)) ||
          (row.contact_no &&
            row.contact_no.toString().toLowerCase().includes(term)) ||
          (row.grade_name && row.grade_name.toLowerCase().includes(term)) ||
          (row.section_id &&
            row.section_id.toString().toLowerCase().includes(term)),
      ),
    );

    setSearchResults(filteredData);
  }, [searchQuery, allSearchData]);

  const handleSearchChangeStudent = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleStudentSelect = (student) => {
    if (!student) return;

    setSelectedStudent({
      id: student.id,
      name: `${student.first_name} ${student.last_name}`,
      role: student.role_name,
      grade: student.grade_name,
      section: student.section_id,
    });
    if (student.role_name === "Student") {
      setIsStudentSelected(true);
    }
    setSearchQuery(""); // Clear the search input
    setSearchResults([]); // Clear the results list
  };

  const openOpenIssueKit = (event) => {
    setOpenIssueKitDialog(true);
  };

  // Fetch products from the backend API
  // const fetchKits = async (query) => {
  //   setLoadingProduct(true);
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_JHS_DEVELOPMENT
  //       }/kits/getsearchresult?search=${encodeURIComponent(query)}`
  //     );
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch products");
  //     }
  //     const data = await response.json();
  //     // Function to sanitize strings by trimming and collapsing spaces

  //     const filteredData = data.filter((row) => {

  //       // if (!row.quantity || row.quantity <= 0) return false;
  //       const searchTerms = searchQueryKit
  //         .toLowerCase()
  //         .split(" ")
  //         .filter(Boolean); // Split on spaces and remove empty strings
  //       return searchTerms.every(
  //         (term) =>
  //           (row.kit_id &&
  //             row.kit_id.toString().toLowerCase().includes(term)) ||
  //           (row.kit_name &&
  //             row.kit_name.toLowerCase().includes(term)) ||
  //           (row.kit_description && row.kit_description.toLowerCase().includes(term)) ||
  //           (row.quantity &&
  //             row.quantity.toString().toLowerCase().includes(term)) ||
  //           (row.total_price &&
  //             row.total_price.toString().toLowerCase().includes(term))
  //       );
  //     });
  //     setSearchResultsKit(filteredData);
  //     setDeletedRows(null);
  //   } catch (error) {
  //     console.error("Error fetching products:", error);
  //   } finally {
  //     setLoadingProduct(false);
  //   }
  // };

  useEffect(() => {
    const fetchKits = async () => {
      setLoadingProduct(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/kits/getsearchresult`,
        );
        if (!response.ok) throw new Error("Failed to fetch kits");

        const data = await response.json();
        setAllKitData(data);
      } catch (error) {
        console.error("Error fetching kits:", error);
      } finally {
        setLoadingProduct(false);
      }
    };

    fetchKits();
  }, []);

  useEffect(() => {
    if (!searchQueryKit.trim()) {
      setSearchResultsKit([]);
      return;
    }

    const searchTerms = searchQueryKit.toLowerCase().split(" ").filter(Boolean);

    const filtered = allKitData.filter((row) =>
      searchTerms.every(
        (term) =>
          (row.kit_id && row.kit_id.toString().toLowerCase().includes(term)) ||
          (row.kit_name && row.kit_name.toLowerCase().includes(term)) ||
          (row.kit_description &&
            row.kit_description.toLowerCase().includes(term)) ||
          (row.quantity &&
            row.quantity.toString().toLowerCase().includes(term)) ||
          (row.total_price &&
            row.total_price.toString().toLowerCase().includes(term)),
      ),
    );

    setSearchResultsKit(filtered);
    setDeletedRows(null);
  }, [searchQueryKit, allKitData]);

  const handleKitSelect = (kit) => {
    let isAlreadySelected = false;
    if (kit.quantity === 0) {
      setSnackbarMessage("This kit is out of stock.");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
      return; // Stop execution if product is out of stock
    }
    setSelectedKit((prev) => {
      if (prev?.kit_id === kit.kit_id) {
        setSnackbarMessage("This kit is already selected.");
        setSnackbarMessageColor("error");
        setShowSnackbarMessage(true);
        return prev; // Keep the existing kit (no change)
      }

      const updatedKit = {
        ...kit,
        maxQuantity: kit.quantity,
        quantity: 1,
        kit_quantity: kit.quantity,
      };

      return updatedKit; // Store only one kit instead of an array
    });

    // Show snackbar **outside** of setSelectedProducts
    if (isAlreadySelected) {
      setSnackbarMessage("This kit is already selected.");
      setSnackbarMessageColor("error");
      setShowSnackbarMessage(true);
    }

    setSearchQueryKit("");
    setSearchResultsKit([]);
  };

  // Handle search input change
  const handleSearchChangeKit = (event) => {
    let studentError = "";

    if (!selectedStudent || selectedStudent.length === 0) {
      studentError = "Student / Staff is required";
    }

    if (studentError) {
      setStudentError(studentError);
      return;
    }

    setStudentError("");
    setKitError("");
    setSearchQueryKit(event.target.value);
  };

  const handleClose = () => {
    setOpenIssueKitDialog(false);
    setSearchQuery("");
    setSelectedStudent("");
    setSearchQueryKit("");
    setSelectedKit("");
    setOpenDelete(false);
    setDeletedRows();
    setKitError("");
    setStudentError("");
    setIsStudentSelected(false);
    setAssignnedKitId(null);
    setSearchQueryKit("");
    setSearchResultsKit([]);

    // reset();
  };
  const handleSort = (property) => {
    let newOrder = sortOrder === "asc" ? "desc" : "asc";

    setSortOrder(newOrder);
    setSortColumn(property);
  };
  useEffect(() => {
    const fetchUserData = async () => {
      const email = localStorage.getItem("user_email");
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_JHS_DEVELOPMENT}/profile/profiledata`,
          { email },
          { headers: { user_email: email } },
        );

        if (response.status === 200) {
          setUserId(response.data.user.user_id);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchUserData();
  }, []);

  //Arohi
  //Added Sorting and Pagination
  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Sorting comparator
  const comparator = (a, b) => {
    if (order === "asc") {
      return a[orderBy] < b[orderBy] ? -1 : 1;
    }
    return a[orderBy] > b[orderBy] ? -1 : 1;
  };

  const filteredData = Array.isArray(assignedKits)
    ? assignedKits.filter((row) => {
        const searchTerm = search.trim().toLowerCase();

        if (!searchTerm) return true;

        const searchWords = searchTerm.split(/\s+/);

        return searchWords.every((word) => {
          return (
            (row.staff_name?.toLowerCase() || "").includes(word) ||
            (row.student_name?.toLowerCase() || "").includes(word) ||
            (row.staff_roles?.toLowerCase() || "").includes(word) ||
            (row.student_role?.toLowerCase() || "").includes(word) ||
            (row.staff_contact_no?.toString() || "").includes(word) ||
            (row.student_contact_no?.toLowerCase() || "").includes(word) ||
            (row.issue_date?.toString() || "").includes(word) ||
            (row.payment_date?.toString() || "").includes(word) ||
            (row.issued_by_name?.toLowerCase() || "").includes(word) ||
            (row.assigned_kit_id?.toString() || "").includes(word) ||
            (row.kit_name?.toLowerCase() || "").includes(word) ||
            (
              row.total_price?.replace(/[^0-9.]/g, "").toLowerCase() || ""
            ).includes(word) ||
            (row.kit_status?.toLowerCase() || "").includes(word)
          );
        });
      })
    : [];
  // Apply sorting to filtered data
  const sortedRows = [...filteredData].sort(comparator);

  // Apply pagination to the sorted data
  const paginatedRows = sortedRows.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );
  //download reciept
   const handleDownloadReciept = async (row, event) => {
    event.stopPropagation();
    const doc = new jsPDF();

    // Institute config
       const institute = getInstituteConfig(instituteId);
       // Add Logo and Header
       doc.setFillColor("#0A64A2");
       const headerHeight = 20;
       doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");
       doc.setFontSize(14);
       doc.setTextColor(255, 255, 255);
       const textyy = 11;
       doc.setFont("helvetica", "bold");
   
       // School name
       doc.text(
         institute.name,  // ✅ dynamic
         doc.internal.pageSize.getWidth() / 2,
         textyy,
         { align: "center" }
       );
   
       // Logo
       if (institute.logo) {
         doc.addImage(institute.logo, "PNG", 8, 1, 28, 18);  // ✅ dynamic
       }
   
       // Address
       doc.setTextColor(0, 0, 0);
       const textStartY = 15;
       doc.setFontSize(10);
       doc.setFont("helvetica", "normal");
       doc.text(
         institute.address1,  // ✅ dynamic
         doc.internal.pageSize.getWidth() / 2,
         textStartY + 10,
         { align: "center" }
       );
       doc.text(
         institute.address2,  // ✅ dynamic
         doc.internal.pageSize.getWidth() / 2,
         textStartY + 14,
         { align: "center" }
       );
       if (institute.tel) {
         doc.text(
           institute.tel,  // ✅ dynamic, skipped for JPS
           doc.internal.pageSize.getWidth() / 2,
           textStartY + 18,
           { align: "center" }
         );
       }
    // Add Receipt Title, Number, and Date - Right aligned
    const receiptTextY = textStartY + 30; // Position the receipt content slightly lower
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    if (row.kit_status === "Paid") {
      doc.text(
        "KIT PROCUREMENT RECEIPT",
        doc.internal.pageSize.getWidth() / 2,
        receiptTextY,
        { align: "center" }
      ); // Center aligned title
    } else {
      doc.text(
        "ISSUE KIT RECEIPT",
        doc.internal.pageSize.getWidth() / 2,
        receiptTextY,
        { align: "center" }
      ); // Center aligned title
    }
    doc.setFontSize(10);



    //Constants for alignment
    const studentLabelX = 14;
    const grade = `${row.student_name !== " " ? row.student_name : row.staff_name} `;
    const feesSlab = `${row.student_role || row.staff_roles || ""}`;
    const feesPending = `${row.student_grade || ""}`;
    const section = `${row.student_section || ""}`;



    // Add Grade, Fees Slab, Pending Fees, and Section dynamically
    const studentDetailsY = receiptTextY + 10;

    // Set font for student name and details
    doc.setFont('helvetica', 'bold');

    // Handle long student name (Grade)
    const gradeWidth = doc.getTextWidth(grade);  // Get width of grade text
    const maxGradeWidth = 70;  // Max width before wrapping
    const splitGrade = gradeWidth > maxGradeWidth ? doc.splitTextToSize(grade, maxGradeWidth) : grade;

    doc.text(`Name: `, studentLabelX, studentDetailsY);  // Left aligned
    doc.setFont('helvetica', 'normal');
    doc.text(splitGrade, studentLabelX + 11, studentDetailsY);  // Adjust X position for grade

    // Dynamically calculate X position for Fees Slab based on Grade length
    const gradeXEnd = studentLabelX + 13 + (gradeWidth > maxGradeWidth ? maxGradeWidth : gradeWidth) + 5;  // End of grade text + 10 for padding

    // Set font and add Fees Slab
    doc.setFont('helvetica', 'bold');
    doc.text('Role: ', gradeXEnd, studentDetailsY);  // Start after grade
    doc.setFont('helvetica', 'normal');
    const feesSlabWidth = doc.getTextWidth(feesSlab);  // Calculate width of fees slab
    doc.text(feesSlab, gradeXEnd + 9, studentDetailsY);  // Position fees slab with dynamic spacing

    // Dynamically calculate X position for Pending Fees based on Fees Slab length
    const feesSlabXEnd = gradeXEnd + 10 + feesSlabWidth + 5;  // End of fees slab text + 10 for padding

    // Set font and add Pending Fees
    doc.setFont('helvetica', 'bold');
    doc.text('Grade: ', feesSlabXEnd, studentDetailsY);  // Start after fees slab
    doc.setFont('helvetica', 'normal');
    const pendingFeesWidth = doc.getTextWidth(feesPending);  // Calculate width of pending fees
    doc.text(feesPending, feesSlabXEnd + 12, studentDetailsY);  // Adjust X position for pending fees

    // Dynamically calculate X position for Section based on Pending Fees length
    const pendingFeesXEnd = feesSlabXEnd + 15 + pendingFeesWidth + 5;  // End of pending fees text + 10 for padding

    // Set font and add Section
    doc.setFont('helvetica', 'bold');
    doc.text('Section: ', pendingFeesXEnd, studentDetailsY);  // Start after pending fees
    doc.setFont('helvetica', 'normal');
    doc.text(section, pendingFeesXEnd + 14, studentDetailsY);  // Adjust X position for section
    // Table for Particulars (example data)
    const receiptDetails = [
      { title: "Indent ID", value: row.assigned_kit_id },
      { title: "Kit Name", value: row.kit_name },
      { title: "Contact No", value: row.student_contact_no || row.staff_contact_no },

       { title: "Amount Paid", value: row.amount_paid.replace(/[^0-9.]/g, '') },
        { title: "Payment Date", value: row.payment_date },

      { title: "Issued By", value: row.issued_by_name },
      { title: "Issue Date", value: row.issue_date },
      { title: "Quantity", value: row.quantity },
      // { title: "Total Amount",value: row.total_price ? row.total_price.replace(/[^0-9.]/g, '') : "0.00"   },
      { title: "Status", value: row.kit_status },



    ];

    const kitProductsData = await getKitProducts(row.kit_id); // this needs to be awaited if it's async
    const productsList = (kitProductsData?.kitProduct || []).map((product, index) => {
      return `${index + 1}. Product: ${product.product_name},  Quantity: ${product.quantity},  Price: ${product.price}`;
    });

    // Push into receiptDetails
    receiptDetails.push({ title: "Product List", value: productsList.join("\n") });

    doc.autoTable({
      head: [["Particulars", "Amount"]],
      body: receiptDetails.map((item) => {
        if (item.title === "Status") {
          return [
            { content: item.title, styles: { fontStyle: "normal" } }, // Bold title
            { content: item.value, styles: { fontStyle: "bold" } }, // Bold value
          ];
        } else {
          return [item.title, item.value]; // Normal styling for other rows
        }
      }),
      startY: receiptTextY + 13, // Start table below student details
      styles: { fontSize: 10, cellPadding: 2 }, // Adjust padding for consistency
      headStyles: {
        fillColor: "#0A64A2", // Blue header
        textColor: [255, 255, 255], // White text
        halign: "left", // Center-align header text
      },
      bodyStyles: {
        halign: "left", // Align text to the left in the body
      },
      columnStyles: {
        0: { cellWidth: 70, halign: "left" }, // Narrower left column
        1: { cellWidth: 110, halign: "left" }, // Wider right column
      },
      theme: "grid",
    });
    const currentDate = new Date();

    // Format the date as DD/MM/YYYY
    const formattedDate = `${String(currentDate.getDate()).padStart(
      2,
      "0"
    )}/${String(currentDate.getMonth() + 1).padStart(
      2,
      "0"
    )}/${currentDate.getFullYear()}`;

    // Add the text with the current date
    doc.setFont("helvetica", "bold");
    doc.text(`Date: ${formattedDate}`, 14, doc.previousAutoTable.finalY + 40);
    doc.setFont("helvetica", "bold");
    doc.text("Authorized Signatory", 158, doc.previousAutoTable.finalY + 40); // Right aligned for signature

    // Save the PDF
    if (row.kit_status === "Paid") {
      doc.save(
        `kit-procurement-receipt_${new Date().toISOString().slice(0, 10)}.pdf`
      );
    } else {
      doc.save(
        `issue-kit-receipt_${new Date().toISOString().slice(0, 10)}.pdf`
      );
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <Layout />

      <div>
        <h1 className="sales-title">Issue Kits</h1>
      </div>
      {/* <br /> */}
      <div className="fees_report_box">
        <Stack spacing={4} direction="row">
          <Stack direction="row" spacing={2} alignItems="center">
            {" "}
            {/* Search Box */}
            <Box component="form" className="search-box">
              <TextField
                label="Search..."
                variant="outlined"
                fullWidth
                value={search}
                onChange={(event) => {
                  setSearch(event.target.value);
                  setPage(0);
                }}
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <IconButton
                        type="button"
                        sx={{ p: "10px" }}
                        aria-label="search"
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
            <Box sx={{ minWidth: 100 }}>
              <FormControl sx={{ minWidth: 100 }} size="small">
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={statusName}
                  label="Grade"
                  onChange={handleStatusChange}
                >
                  {status.map((s) => (
                    <MenuItem key={s.description} value={s.description}>
                      {s.description}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Stack>
          <div className="download-report-box-fees-report">
            <Button
              onClick={() => openOpenIssueKit()}
              style={{
                background: "#0A64A2",
                color: "#fff",
                marginRight: "5px",
              }}
            >
              {" "}
              Issue Kit{" "}
            </Button>
            <Button
              className="create-sale-btn"
              // sx={{background:'#0A64A2',padding:"7.5px"}}
              variant="contained"
              onClick={handleDownload}
              startIcon={<DownloadIcon />}
            >
              Download Report
            </Button>
          </div>
        </Stack>
      </div>
      {/* <br /> */}

      <Box className="table-container">
        <Box className="table-container">
          <Paper className="table-container-paper">
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 750 }}
                aria-label="custom pagination table"
              >
                <TableHead align="center">
                  <TableRow>
                    <StyledTableCell
                      sortDirection={
                        orderBy === "issue_product_id" ? order : false
                      }
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "assigned_kit_id"}
                        direction={
                          orderBy === "assigned_kit_id" ? order : "asc"
                        }
                        onClick={() => handleRequestSort("assigned_kit_id")}
                      >
                        Indent ID
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      sortDirection={orderBy === "student_name" ? order : false}
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "student_name"}
                        direction={orderBy === "student_name" ? order : "asc"}
                        onClick={() => handleRequestSort("student_name")}
                      >
                        Name
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      sortDirection={orderBy === "staff_name" ? order : false}
                      align="center"
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "staff_name"}
                        direction={orderBy === "staff_name" ? order : "asc"}
                        onClick={() => handleRequestSort("staff_name")}
                      >
                        Role
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "34px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "student_contact_no"}
                        direction={
                          orderBy === "student_contact_no" ? order : "asc"
                        }
                        onClick={() => handleRequestSort("student_contact_no")}
                      >
                        Contact No
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "kit_name"}
                        direction={orderBy === "kit_name" ? order : "asc"}
                        onClick={() => handleRequestSort("kit_name")}
                      >
                        Kit Name
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "payment_date"}
                        direction={orderBy === "payment_date" ? order : "asc"}
                        onClick={() => handleRequestSort("payment_date")}
                      >
                        Payment Date
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issue_date"}
                        direction={orderBy === "issue_date" ? order : "asc"}
                        onClick={() => handleRequestSort("issue_date")}
                      >
                        Issue Date
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell
                      align="center"
                      // style={{ paddingLeft: "30px" }}
                      className="sales_tablecell"
                    >
                      <TableSortLabel
                        active={orderBy === "issued_by_name"}
                        direction={orderBy === "issued_by_name" ? order : "asc"}
                        onClick={() => handleRequestSort("issued_by_name")}
                      >
                        Issued By
                      </TableSortLabel>
                    </StyledTableCell>

                    <StyledTableCell align="center" className="sales_tablecell">
                      <TableSortLabel
                        active={orderBy === "kit_status"}
                        direction={orderBy === "kit_status" ? order : "asc"}
                        onClick={() => handleRequestSort("kit_status")}
                      >
                        Status
                      </TableSortLabel>
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Issued
                    </StyledTableCell>
                    <StyledTableCell align="center" className="sales_tablecell">
                      Product
                    </StyledTableCell>

                    <StyledTableCell align="center" className="sales_tablecell">
                      Receipt
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                {loading ? (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={12} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                ) : (
                  <TableBody>
                    {rowsPerPage.length > 0
                      ? paginatedRows.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                      : paginatedRows.map((row) => (
                          <StyledTableRow
                            style={{ cursor: "pointer", textAlign: "center" }}
                            key={row.assigned_kit_id}
                            tabIndex={-1}
                            padding="none"
                            onClick={(event) => {
                              // Check if the clicked element is inside an ignored component
                              if (
                                event.target.closest(".receipt-icon") ||
                                event.target.closest(".product-icon") ||
                                event.target.type === "checkbox"
                              ) {
                                return; // Ignore click
                              }

                              handleSelectRow(
                                row.assigned_kit_id,
                                row.student_id,
                                row.staff_id,
                                row.staff_name,
                                row.student_name,
                                row.student_role,
                                row.staff_roles,
                                row.student_grade,
                                row.student_section,
                                row.kit_id,
                                row.total_price,
                                row.kit_name,
                                row.kit_description,
                                row.quantity,
                                row.kit_quantity,
                                row.kit_status,
                              );
                            }}
                          >
                            <StyledTableCell
                              component="th"
                              scope="row"
                              padding="none"
                              align="center"
                              className="table_content"
                            >
                              {row.assigned_kit_id}
                            </StyledTableCell>
                            <StyledTableCell
                              component="th"
                              scope="row"
                              padding="none"
                              align="center"
                              className="table_content"
                            >
                              {row.student_name !== " "
                                ? row.student_name
                                : row.staff_name}
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              className="table_content"
                            >
                              {row.staff_roles || row.student_role}
                            </StyledTableCell>

                            <StyledTableCell
                              align="center"
                              className="table_content"
                            >
                              {row.staff_contact_no || row.student_contact_no}
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              className="table_content"
                            >
                              {row.kit_name}
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              className="table_content"
                            >
                              {row.payment_date}
                            </StyledTableCell>

                            <StyledTableCell
                              align="center"
                              className="table_content"
                            >
                              {row.issue_date}
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              className="table_content"
                            >
                              {row.issued_by_name}
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              className="table_content"
                            >
                              {row.kit_status}
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              style={{ padding: "0" }}
                            >
                              {row.kit_status === "Issued" ? (
                                <CheckBoxIcon
                                  style={{ color: "rgb(143 134 134 / 87%)" }}
                                ></CheckBoxIcon>
                              ) : (
                                <Checkbox
                                  checked={row.description === "Issued"}
                                  disabled={row.description === "Issued"}
                                  onChange={() => handleCheckboxClick(row)}
                                />
                              )}
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              style={{ padding: "0" }}
                            >
                              <ListAltIcon
                                className="product-icon"
                                style={{ marginLeft: 8, color: "#0A64A2" }}
                                onClick={(event) => {
                                  event.stopPropagation(); // Stop click from triggering row click
                                  handleProductList(row.kit_id);
                                }}
                              />
                            </StyledTableCell>

                            <StyledTableCell align="center">
                              <Button
                                variant="text"
                                className="receipt-icon"
                                startIcon={<DownloadIcon />}
                                style={{ padding: "0" }}
                                onClick={(event) => {
                                  event.stopPropagation(); // Stop click from triggering row click
                                  if (
                                    row.kit_status === "Paid" ||
                                    row.kit_status === "Issued"
                                  ) {
                                    handleDownloadReciept(row, event);
                                  }
                                }}
                              />
                            </StyledTableCell>
                          </StyledTableRow>
                        ))}
                  </TableBody>
                )}
                <TableFooter className="table-footer">
                  <TableRow className="table-header">
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 20]}
                      count={sortedRows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      className="table-pagination"
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Box>

      <Dialog
        open={openIssueKitDialog}
        onClose={handleClose}
        maxWidth="100%"
        fullWidth
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "8px",
            paddingBottom: "0",
            paddingTop: "0",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ color: "rgb(169, 156, 156)", paddingBottom: "0" }}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div
          className="main_title"
          style={{ paddingLeft: "26px", paddingBottom: "1px" }}
        >
          <img
            src={issueKitIcon}
            alt="issueKitIcon"
            style={{ height: "30px", marginBottom: "-4px" }}
          />
          <span className="create-sale">
            {assignedKitId ? "Edit Issue Kit" : "Issue Kit"}
          </span>
        </div>

        <Divider
          className="divider"
          style={{ width: "97%", marginLeft: "25px" }}
        />
        <DialogContent style={{ paddingTop: "10px" }}>
          <Stack padding={1}>
            <Stack spacing={2} direction="row">
              <Stack spacing={1} direction="column" className="form-stack">
                {!assignedKitId && (
                  <div className="create_search">
                    {/* Search Field and Proceed Button */}
                    <div style={{ display: "flex" }}>
                      <div className="create_search1">
                        <TextField
                          sx={{ minWidth: 600, marginBottom: "4px" }}
                          label={
                            studentError
                              ? studentError
                              : "Search Student / Staff"
                          }
                          error={!!studentError}
                          variant="outlined"
                          fullWidth
                          value={searchQuery}
                          onChange={handleSearchChangeStudent}
                          size="small"
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <IconButton type="button" aria-label="search">
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                            endAdornment: (
                              <InputAdornment position="end">
                                {loadingStudent ? (
                                  <CircularProgress size={18} />
                                ) : null}
                              </InputAdornment>
                            ),
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}

                {searchQuery.trim() !== "" && searchResults.length > 0 && (
                  <List
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "0",
                      width: 600,
                    }}
                  >
                    {searchResults.map((student, index) => (
                      <ListItem
                        button
                        key={`${student.id}-${index}`}
                        onClick={() => handleStudentSelect(student)}
                      >
                        <ListItemText primary={student.id} />
                        <ListItemText
                          primary={student.first_name + " " + student.last_name}
                        />
                        <ListItemText primary={student.role_name} />
                        <ListItemText primary={student.grade_name} />
                        <ListItemText primary={student.section_id} />
                      </ListItem>
                    ))}
                  </List>
                )}

                <div className="main_title1">
                  Name: {selectedStudent?.name} &nbsp;&nbsp; Role:{" "}
                  {selectedStudent?.role}&nbsp;&nbsp; Grade:{" "}
                  {selectedStudent?.grade} &nbsp;&nbsp; Section:
                  {selectedStudent?.section}
                </div>

                <div
                  style={{
                    margin: "20px 0",
                    fontSize: 15,
                    fontWeight: "bold",
                    color: "#0A64A2",
                    paddingTop: "0",
                  }}
                >
                  Indent ID: {assignedKitId} &nbsp;&nbsp;
                </div>
              </Stack>
            </Stack>

            <div className="create_search">
              {/* Search Field and Proceed Button */}
              <div style={{ display: "flex" }}>
                <div className="create_search1">
                  <TextField
                    sx={{
                      minWidth: 700,
                      marginBottom: "4px",
                      marginTop: "0px",
                    }}
                    id="outlined-basic"
                    name="selectProduct"
                    size="small"
                    variant="outlined"
                    required
                    value={searchQueryKit}
                    onChange={handleSearchChangeKit}
                    label={kitError ? kitError : "Search Kit"}
                    error={!!kitError}
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            type="button"
                            sx={{ p: "0px" }}
                            aria-label="search"
                          >
                            <SearchIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          {loadingProduct ? (
                            <CircularProgress size={18} />
                          ) : null}
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="sale-div-issue-kit">
                  <div className="sale-delete-div">
                    <Button
                      variant="contained"
                      color="primary"
                      disabled={isLoading}
                      onClick={() => {
                        if (assignedKitId) {
                          if (selectedKit?.kit_quantity > 0) {
                            EditAssignedKit();
                          } else {
                            triggerSnackbar(
                              "Selected kit is out of stock. Please select another kit or contact the Store Manager.",
                              "error",
                            );
                          }
                        } else {
                          saveAssignedKit();
                        }
                      }}
                      className="save_update_btn"
                    >
                      {/* {assignedKitId ? "Update" : "Save"} */}
                      {isLoading
                        ? "Saving..."
                        : assignedKitId
                          ? "Update"
                          : "Save"}
                    </Button>
                    {/* <Button
                      variant="contained"
                      color="primary"
                      onClick={handleDeleteProduct}
                      className="sale-delete-btn"
                    >
                      Delete
                    </Button> */}
                  </div>
                </div>
              </div>

              {/* Search Results List */}
              {searchQueryKit.trim() !== "" && searchResultsKit.length > 0 && (
                <List
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    padding: "0",
                    width: 700,
                  }}
                >
                  {searchResultsKit.map((kit) => (
                    <ListItem
                      button
                      key={kit.id}
                      onClick={() => handleKitSelect(kit)}
                    >
                      <ListItemText primary={kit.kit_name} />
                      <ListItemText primary={kit.kit_description} />
                      <ListItemText primary={kit.quantity} />
                      <ListItemText primary={kit.total_price} />
                      {/* <ListItemText primary={kit.quantity} /> */}
                    </ListItem>
                  ))}
                </List>
              )}
            </div>

            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 750 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center"> Kit Id </StyledTableCell>

                    <StyledTableCell align="center"> Kit Name </StyledTableCell>
                    <StyledTableCell align="center">
                      {" "}
                      Description{" "}
                    </StyledTableCell>

                    <StyledTableCell align="center">Price </StyledTableCell>
                    <StyledTableCell align="center"> Quantity </StyledTableCell>
                    <StyledTableCell align="center">
                      Available Stock{" "}
                    </StyledTableCell>

                    <StyledTableCell align="center">
                      {" "}
                      Product List{" "}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                {selectedKit && selectedKit !== "" ? (
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell align="center">
                        {selectedKit?.kit_id}
                        {deletedRows?.kit_id === selectedKit?.kit_id && (
                          <div
                            style={{
                              position: "absolute",
                              top: assignedKitId ? "75%" : "77%",
                              left: 0,
                              width: "90%",
                              height: "2px",
                              backgroundColor: "red",
                              transform: "translateY(-50%)",
                              marginLeft: "30px",
                              // paddingLeft:'20px'
                            }}
                          />
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {selectedKit?.kit_name}
                        {deletedRows?.kit_id === selectedKit?.kit_id && (
                          <div
                            style={{
                              position: "absolute",
                              top: assignedKitId ? "75%" : "77%",
                              left: 0,
                              width: "90%",
                              height: "2px",
                              backgroundColor: "red",
                              transform: "translateY(-50%)",
                              marginLeft: "30px",
                              // paddingLeft:'20px'
                            }}
                          />
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {selectedKit?.kit_description}
                        {deletedRows?.kit_id === selectedKit?.kit_id && (
                          <div
                            style={{
                              position: "absolute",
                              top: assignedKitId ? "75%" : "77%",
                              left: 0,
                              width: "90%",
                              height: "2px",
                              backgroundColor: "red",
                              transform: "translateY(-50%)",
                              marginLeft: "30px",
                              // paddingLeft:'20px'
                            }}
                          />
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {parseFloat(
                          selectedKit?.total_price?.replace(/[₹,]/g, ""),
                        ) || null}
                        {deletedRows?.kit_id === selectedKit?.kit_id && (
                          <div
                            style={{
                              position: "absolute",
                              top: assignedKitId ? "75%" : "77%",
                              left: 0,
                              width: "90%",
                              height: "2px",
                              backgroundColor: "red",
                              transform: "translateY(-50%)",
                              marginLeft: "30px",
                              // paddingLeft:'20px'
                            }}
                          />
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {selectedKit?.quantity}
                        {deletedRows?.kit_id === selectedKit?.kit_id && (
                          <div
                            style={{
                              position: "absolute",
                              top: assignedKitId ? "75%" : "77%",
                              left: 0,
                              width: "90%",
                              height: "2px",
                              backgroundColor: "red",
                              transform: "translateY(-50%)",
                              marginLeft: "30px",
                              // paddingLeft:'20px'
                            }}
                          />
                        )}
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {selectedKit?.kit_quantity}
                        {deletedRows?.kit_id === selectedKit?.kit_id && (
                          <div
                            style={{
                              position: "absolute",
                              top: assignedKitId ? "75%" : "77%",
                              left: 0,
                              width: "90%",
                              height: "2px",
                              backgroundColor: "red",
                              transform: "translateY(-50%)",
                              marginLeft: "30px",
                            }}
                          />
                        )}
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ padding: "0", position: "relative" }}
                      >
                        <ListAltIcon
                          className="product-icon"
                          style={{ marginLeft: 8, color: "#0A64A2" }}
                          onClick={(event) => {
                            event.stopPropagation(); // Stop click from triggering row click
                            handleProductList(selectedKit?.kit_id);
                          }}
                        />
                      </StyledTableCell>

                      {/* <StyledTableCell align="center" style={{ lineHeight: "10px", padding: "5px" }}>
                        <IconButton color="black" onClick={() => handleToggleDelete(selectedKit?.kit_id, selectedKit?.quantity)}>
                          <DeleteIcon />
                        </IconButton>
                      </StyledTableCell> */}
                    </StyledTableRow>
                  </TableBody>
                ) : null}
              </Table>
            </TableContainer>

            <TablePagination
              style={{ backgroundColor: "#0A64A2", color: "#fff" }}
              rowsPerPageOptions={[5, 10, 15]}
              component="div"
              count={selectedKit ? 1 : 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Stack>
        </DialogContent>
      </Dialog>

      {/* Delete Confirmation Dialog */}

      <Dialog
        open={openDelete}
        onClose={handleCancelDelete}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            {deletedRows
              ? "Are you sure you want to delete this selected Kit?"
              : "Please select kit before deleting."}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {" "}
          {/* Center-align the buttons */}
          {deletedRows ? (
            <Button
              variant="contained"
              onClick={handleDeleteConfirm}
              className="no-btn"
            >
              Yes
            </Button>
          ) : (
            ""
          )}
          <Button
            variant="contained"
            onClick={handleCancelDelete}
            autoFocus
            className="no-btn"
          >
            {deletedRows ? "No" : "Ok"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Product List Dialog */}
      <Dialog
        open={open}
        onClose={handleCloseProducts}
        maxWidth="lg"
        fullWidth={false}
        PaperProps={{
          style: {
            maxHeight: "90vh",
            boxShadow: "0",
          },
        }}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <IconButton
          onClick={handleCloseProducts}
          style={{
            color: "#817575",
            position: "absolute",
            right: "4px",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box>
          <DialogTitle
            style={{
              color: "#0A64A2",
              padding: "0px 11px", // Adjust padding for a more compact look
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0",
              marginTop: "15px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <ListAltIcon style={{ paddingBottom: "0", marginTop: "7px" }} />
              <span
                style={{
                  marginLeft: "4px",
                  fontWeight: "bold",
                  fontSize: "18px",
                  marginTop: "10px",
                }}
              >
                {/* Product list for {(assignedKitId ? selectedKit?.kit_name : kitProducts?.kitProduct[0]?.kit_name)} */}
                Product list for {kitName}
              </span>
            </div>
          </DialogTitle>
        </Box>
        <Divider
          className="divider"
          style={{ width: "96%", marginLeft: "13px" }}
        />
        <DialogContent style={{ padding: "0", margin: "0px 10px" }}>
          <div
            // key={type}
            style={{ marginBottom: "4px" }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell style={{ color: "#0A64A2", padding: "4px" }}>
                    {" "}
                    Sl.No
                  </TableCell>
                  <TableCell style={{ color: "#0A64A2", padding: "4px" }}>
                    {" "}
                    Product Name{" "}
                  </TableCell>
                  <TableCell style={{ color: "#0A64A2", padding: "4px" }}>
                    Attribute{" "}
                  </TableCell>

                  <TableCell style={{ color: "#0A64A2", padding: "4px" }}>
                    Quantity{" "}
                  </TableCell>
                  <TableCell style={{ color: "#0A64A2", paddingLeft: "4px" }}>
                    {" "}
                    Price
                  </TableCell>
                  <TableCell style={{ color: "#0A64A2", padding: "4px" }}>
                    {" "}
                    Total Price{" "}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(kitProducts?.kitProduct || []).map((p, index) => (
                  <TableRow key={p.product_id}>
                    <TableCell className="table-cell-product-list">
                      {index + 1}
                    </TableCell>
                    <TableCell align="left" style={{ padding: "4px" }}>
                      {" "}
                      {p.product_name}
                    </TableCell>
                    <TableCell align="left" style={{ padding: "4px" }}>
                      {p.attribute_name} : {p.attribute_value}
                    </TableCell>

                    <TableCell align="center" style={{ padding: "4px" }}>
                      {p.quantity}
                    </TableCell>
                    <TableCell align="center" style={{ paddingLeft: "4px" }}>
                      {" "}
                      {p.price}
                    </TableCell>
                    <TableCell align="center" style={{ padding: "4px" }}>
                      {" "}
                      {p.price * p.quantity}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: "10px",
                fontWeight: "bold",
                fontSize: "0.9rem",
                marginTop: "5px",
              }}
            >
              <span
                style={{
                  color: "#0A64A2",
                }}
              >
                Total Price:
              </span>
              &nbsp;
              <span style={{ color: "rgb(58 48 48 / 87%)" }}>
                {totalProductPrice.toFixed(2)}
              </span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={showSnackbarMessage}
        autoHideDuration={selectedKit?.kit_quantity === 0 ? null : 3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => {
          setShowSnackbarMessage(false);
        }}
        message={snackbarMessage}
      >
        <Alert
          severity={snackbarMessageColor}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* check box  */}
      <Dialog
        open={checkBoxOpen}
        onClose={closeCheckBox}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" },
        }}
      >
        <DialogContent
          style={{
            paddingLeft: dialogType === "confirmation" ? "15px" : "20px",
          }}
        >
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            {dialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          {dialogType === "confirmation" ? (
            <>
              <Button
                variant="contained"
                onClick={handleIssueKit}
                className="no-btn"
              >
                Yes
              </Button>
              <Button
                variant="contained"
                onClick={closeCheckBox}
                autoFocus
                className="no-btn"
              >
                No
              </Button>
            </>
          ) : (
            <Button
              variant="contained"
              onClick={closeCheckBox}
              autoFocus
              className="no-btn"
            >
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmation}
        onClose={handleCloseConfirm}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "300px", maxWidth: "300px", borderRadius: "5px" }, // Set the width to 300px
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }} // Center align text
          >
            Kit ({selectedKit?.kit_name}) has already been assigned to this{" "}
            {isStudentSelected ? "Student" : "Staff"}.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleCloseConfirm}
            className="no-btn"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmationDuplicate}
        onClose={handleCloseConfirm}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
        PaperProps={{
          sx: { width: "400px", maxWidth: "400px", borderRadius: "5px" },
        }}
      >
        <DialogContent style={{ paddingLeft: "15px" }}>
          <DialogContentText
            id="delete-dialog-description"
            style={{ fontSize: "1.1em", color: "#0A64A2" }}
          >
            Kit ({duplicateKit.join(", ")}) has been already issued to this{" "}
            {isStudentSelected ? "Student" : "Staff"} for the current year. Do
            you want to issue another kit for the same year?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-end" }}>
          <Button
            variant="contained"
            onClick={handleConfirmDuplicateKit}
            className="no-btn"
          >
            Yes
          </Button>
          <Button
            variant="contained"
            onClick={handleCloseConfirm}
            className="no-btn"
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A64A2",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
